import AvatarsApi from './AvatarsApi';
import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import AvatarsCreateEditForm from './Components/AvatarsCreateEditForm';


export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: AvatarsCreateEditForm,
                getCreate: AvatarsApi.create,
                getClone: AvatarsApi.getOne,
                defaults: {},
                successMessage: "Avatar Saved Successfully!",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}